import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user_answers: {},
        code: '',
        userInfoId: '',
        userInfoData: {},
        settingData: {},
        isToken: false,
        formTitle: '',
        isSubmit: false,
        formId: '',
        formType: null,
        surplusTime: null,
        isUpdate: false,
        mobile:'',
        is_rand_flash :true,//设置随机题目时,在提交之前,刷新页面不重新拉取题目
        rand_question :{},//设置随机题目时,记录题目
        isReviewLogin:false,//评议表单登录状态
        openid:'',//微信登录的唯一标识
        headimgurl:'',//获取的微信头像
        isReload:false
    },
    mutations: {
        user_answers(state, content) {
            state.user_answers = content
        },
        //获取表单ID
        formId(state, content) {
            state.formId = content
        },
        //更新答题对象
        updateUserAnswers(state, content) {
            for (let key in content) {
                state.user_answers[key] = content[key]
            }
        },
        //初始化答案对象
        initUserAnswers(state, content) {
            state.user_answers = content
        },
        //答题验证码
        code(state, content) {
            state.code = content
        },
        //收集用户信息
        userInfoData(state, content) {
            state.userInfoData = content
        },
        //收集用户信息的记录id
        userInfoId(state, content) {
            state.userInfoId = content
        },
        //表单配置详情
        settingData(state, content) {
            state.settingData = content
        },
        //是否需要登录媒体云账号，要登录则携带token
        isToken(state, content) {
            state.isToken = content
        },
        //表单标题
        formTitle(state, content) {
            state.formTitle = content
        },
        //是否提交答题
        isSubmit(state, content) {
            state.isSubmit = content
        },
        //表单类型(1：问卷，2：答题 3: 党建答题)
        formType(state, content) {
            state.formType = content
        },
        //答题刷新剩余倒计时
        surplusTime(state, content) {
            state.surplusTime = content
        },
        //移动端刷新是否切换路由到初始页
        isUpdate(state, content) {
            state.isUpdate = content
        },
        saveMobile(state,content){
            state.mobile = content
        },
        //记录登录码
        saveLoginCode(state,content){
            state.loginCode = content
        },
        // 记录随机题目状态 防止刷新重新拉取题目
        saveRandFlash(state,content){
            state.is_rand_flash = content
        },
        // 随机题目时,记录的题目
        saveRandQuestion(state,content){
            state.rand_question = content
        },
        updateReviewLogin(state,content){
            state.isReviewLogin= content
        },
        saveOpenid(state,content){
            state.openid = content;
        },
        saveHeaderImg(state,content){
            state.headimgurl = content;
        },
        isReload(state,content){
            state.isReload = content;
        }
    },
    actions: {
        userAnswersActions(context, payload) {
            context.commit('updateUserAnswers', payload)
        }
    },
    modules: {},

    //配置
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
})
